import Glide from '@glidejs/glide';
import { throttle } from 'throttle-debounce';
import lazyloadify from '../global/lazyload';

let MOBILE_GLIDE_BREAKPOINT = 1024;

/**
 * Standard Glide instantiation
 */

const paginationHelper = (index, limit, ...args) => {
  args.forEach(arg => arg.classList.remove('svg-disable'))
  if (index === 0 || index === limit) {
    if (!index) {
      args[0].classList.add('svg-disable')
    } else if (index === limit) {
      args[1].classList.add('svg-disable')
    }
  } 
}

const ArrowDisabler = (Glide, Components) => {
  // Hide arrows at max slidage
  return {
    mount() {
      // Only in effect when rewinding is disabled
      if (Glide.settings.rewind) {
        return
      }

      Glide.on(['mount.after', 'run'], () => {
        // Set left arrow state
        const left = document.querySelector('[data-glide-arrow-left]')
        if (left) {
          if (Glide.index === 0) {
            left.classList.add('arrow-disabled') // Disable on first slide
          } else {
            left.classList.remove('arrow-disabled') // Enable on other slides
          }
        }

        // Set right arrow state
        const right = document.querySelector('[data-glide-arrow-right]')
        if (right) {
          if (Glide.index === Components.Sizes.length) {
            right.classList.add('arrow-disabled') // Disable on last slide
          } else {
            right.classList.remove('arrow-disabled') // Disable on other slides
          }
        }
      })
    }
  }
}

const glideDomHandler = (glide) => ({
  variantLeftArrow: glide.querySelector('.select-variant span[data-glide-arrow-left]'),
  variantRightArrow: glide.querySelector('.select-variant span[data-glide-arrow-right]'),
  variantSlidesLength: glide.querySelectorAll('.select-variant [data-slides-items]').length,
  variantBullets: glide.querySelector('.select-variant [data-glide-el="controls[nav]"]'),
  leftArrow: glide.querySelector('span[data-glide-arrow-left]'),
  rightArrow: glide.querySelector('span[data-glide-arrow-right]'),
  slidesLength: glide.querySelectorAll('[data-slides-items]').length,
  bullets: glide.querySelector('[data-glide-el="controls[nav]"]'),
  glideMobArrowRight: glide.querySelector('[glide-right].glide__arrow--right'),
  glideMobArrowLeft: glide.querySelector('[glide-left].glide__arrow--left'),
  glideGalleryArrowRight: glide.querySelector('.glide__track .controls.gallery-button-right'),
  glideGalleryArrowLeft: glide.querySelector('.glide__track .controls.gallery-button-left')
})

export const glidify = () => {
  const glides = document.querySelectorAll('[data-glide]');
  if (!glides.length) return;

  glides.forEach((glide) => {
    const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};

    const thisGlide = new Glide(glide, config);
    thisGlide.on('build.after', () => {
      lazyloadify()
    })
    const { bullets, slidesLength, leftArrow, rightArrow, glideMobArrowRight, glideMobArrowLeft, glideGalleryArrowRight, glideGalleryArrowLeft} = glideDomHandler(glide)
    if (bullets && leftArrow && rightArrow) {
      thisGlide.on('run.after', () => {
        paginationHelper(thisGlide.index, slidesLength - 1, leftArrow, rightArrow)
      })
    }


    if (glideMobArrowLeft && glideMobArrowRight) {
      glideMobArrowLeft.addEventListener('click', function() {
        thisGlide.go('<');
      })
         
      glideMobArrowRight.addEventListener('click', function() {
        thisGlide.go('>');
      })
    }

    if (glideGalleryArrowLeft && glideGalleryArrowRight) {
      glideGalleryArrowLeft.addEventListener('click', function() {
        thisGlide.go('<');
      })
         
      glideGalleryArrowRight.addEventListener('click', function() {
        thisGlide.go('>');
      })
    }
    thisGlide.mount();

    const id = glide.dataset.glideId ? glide.dataset.glideId : null;
    window.blubolt.glides[id] = thisGlide;
  });
}

export const glidifyVariants = () => {
  const glides = document.querySelectorAll('[data-glide-pdp-variants]');
  if (!glides.length) return;

  glides.forEach((glide) => {
    const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};

    const thisGlide = new Glide(glide, config);
    thisGlide.on('build.after', () => {
      lazyloadify()
    })
    const { bullets, slidesLength, leftArrow, rightArrow, glideMobArrowRight, glideMobArrowLeft, glideGalleryArrowRight, glideGalleryArrowLeft} = glideDomHandler(glide)
    if (bullets && leftArrow && rightArrow) {
      thisGlide.on('run.after', () => {
        paginationHelper(thisGlide.index, slidesLength - 1, leftArrow, rightArrow)
      })
    }


    if (glideMobArrowLeft && glideMobArrowRight) {
      glideMobArrowLeft.addEventListener('click', function() {
        thisGlide.go('<');
      })
         
      glideMobArrowRight.addEventListener('click', function() {
        thisGlide.go('>');
      })
    }

    if (glideGalleryArrowLeft && glideGalleryArrowRight) {
      glideGalleryArrowLeft.addEventListener('click', function() {
        thisGlide.go('<');
      })
         
      glideGalleryArrowRight.addEventListener('click', function() {
        thisGlide.go('>');
      })
    }
    thisGlide.mount();

    const id = glide.dataset.glideId ? glide.dataset.glideId : null;
    window.blubolt.glides[id] = thisGlide;
  });
}

/**
 * Instantiate glides for mobile only
 */
export const glidifyMob = () => {
  const glides = document.querySelectorAll('[data-glide-mob]');
  if (!glides.length) return;
  const glidesSmall = document.querySelectorAll('[data-glide-mob-small]');
  if (glidesSmall.length) {
    MOBILE_GLIDE_BREAKPOINT = 560
  }
  const initGlideOnMobile = () => {
    // TODO: Swap less than
    if (window.innerWidth >= MOBILE_GLIDE_BREAKPOINT) {
      if (window.blubolt.glides) {
        const keys = Object.keys(window.blubolt.glides);
        keys.forEach((key) => {
          const glideToReinstantiate = window.blubolt.glides[key]
          if (glideToReinstantiate.selector.hasAttribute('data-glide-mob')) {
            window.blubolt.glides[key].destroy()
            delete window.blubolt.glides[key]
          }
        });
      }
    } else if (document.querySelector('[data-glide-pdp-var]')) {
      console.log('loaded')
      glides.forEach((glide) => {
        const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};
        const id = glide.dataset.id ? glide.dataset.id : null;
        if (id) {
          // Only create glide if it hasn't been created yet.
          if (!window.blubolt.glides[id]) {
            const glideInstance = new Glide(glide, config);
            window.blubolt.glides[id] = glideInstance;

            const { variantBullets, variantSlidesLength, variantLeftArrow, variantRightArrow } = glideDomHandler(glide)
            if (variantBullets && variantLeftArrow && variantRightArrow) {
              glideInstance.on('run.after', () => {
                paginationHelper(glideInstance.index, variantSlidesLength - 3, variantLeftArrow, variantRightArrow)
              })
            }
            glideInstance.mount()
          }
          if (window.blubolt.lazyLoadInstance) {
            window.blubolt.lazyLoadInstance.update();
          }
        } else {
          console.info('Please add data-id to the slide');
        }
      });      
    } else {
      glides.forEach((glide) => {
        const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};
        const id = glide.dataset.id ? glide.dataset.id : null;
        if (id) {
          // Only create glide if it hasn't been created yet.
          if (!window.blubolt.glides[id]) {
            const glideInstance = new Glide(glide, config);
            window.blubolt.glides[id] = glideInstance;

            const { bullets, slidesLength, leftArrow, rightArrow } = glideDomHandler(glide)
            if (bullets && leftArrow && rightArrow) {
              glideInstance.on('run.after', () => {
                paginationHelper(glideInstance.index, slidesLength - 1, leftArrow, rightArrow)
              })
            }
            glideInstance.mount()
          }
          if (window.blubolt.lazyLoadInstance) {
            window.blubolt.lazyLoadInstance.update();
          }
        } else {
          console.info('Please add data-id to the slide');
        }
      });      
    }
  }

  ArrowDisabler();
  initGlideOnMobile();
  window.addEventListener('resize', throttle(500, false, () => initGlideOnMobile()));
}

export default glidify